<div
  class="template-massive"
  [ngClass]="{
    'template-massive-custom1': customStyle.customStyle1,
    'template-massive-custom2': customStyle.customStyle2
  }">
  <ng-container *ngIf="template">
    <!-- MESSAGE -->
    <div class="template-massive__main">
      <!-- HEADER -->
      <div class="template-massive__header">
        <!-- HEADER: TEXT -->
        <div
          class="template-massive__header__text"
          *ngIf="template['headerType'] === 'TEXT' || !template['headerType']">
          <span>{{ template['headerText'] }}</span>
        </div>
        <div
          class="template-massive__header__media"
          *ngIf="checkHeaderMediaType(template['headerType'])">
          <button
            mat-mini-fab
            class="button-remove-file"
            (click)="clearFile()"
            *ngIf="selectedFile">
            <mat-icon class="remove-icon">close</mat-icon>
          </button>
          <ng-container *ngIf="template['headerText']; else elseTemplate">
            <!-- HEADER: IMAGE -->
            <img
              *ngIf="template['headerType'] === 'IMAGE'"
              [src]="template['headerText']"
              alt="template-preview"
              [@animate]="{ value: '*', params: { delay: '100ms', y: '25px' } }" />
            <!-- HEADER: DOCUMENT -->
            <object
              *ngIf="template['headerType'] === 'DOCUMENT'"
              [data]="template['headerText'] | safe"
              title="template-preview"
              type="application/pdf"
              [@animate]="{
                value: '*',
                params: { delay: '100ms', y: '25px' }
              }"></object>
            <!-- HEADER: VIDEO -->
            <video
              *ngIf="template['headerType'] === 'VIDEO'"
              controls
              [@animate]="{ value: '*', params: { delay: '100ms', y: '25px' } }">
              <source [src]="template['headerText']" type="video/mp4" />
            </video>
          </ng-container>
          <ng-template #elseTemplate>
            <div
              class="template-massive__header__media-empty"
              [@animate]="{ value: '*', params: { delay: '100ms', y: '25px' } }">
              <mat-icon *ngIf="!isTemplateExample">{{
                mediaEmptyIcon[template['headerType']]
              }}</mat-icon>
              <div class="content-upload-file" *ngIf="isTemplateExample">
                <p class="icon"><mat-icon>cloud_upload</mat-icon></p>
                <a
                  mat-raised-button
                  color="accent"
                  class="button-select-file"
                  (click)="fileInput.click()">
                  SELECCIONAR ARCHIVO
                </a>
              </div>
              <input
                #fileInput
                type="file"
                style="display: none"
                (change)="
                  fileSelected(
                    $event,
                    template['headerType'] === 'IMAGE'
                      ? 'img'
                      : template['headerType'] === 'DOCUMENT'
                        ? 'document'
                        : 'video'
                  )
                "
                readonly
                [accept]="
                  template['headerType'] === 'IMAGE'
                    ? 'image/png, image/jpeg'
                    : template['headerType'] === 'DOCUMENT'
                      ? '.pdf'
                      : 'video/mp4, video/mpeg, video/ogg'
                "
                #fileInput />
            </div>
          </ng-template>
        </div>
      </div>
      <!-- BODY -->
      <div class="template-massive__body">
        <span>{{ template['bodyText'] }}</span>
      </div>
      <!-- FOOTER -->
      <div *ngIf="template['footerText'] !== null" class="template-massive__footer">
        <span>{{ template['footerText'] }}</span>
      </div>
      <!-- BUTTONs CTA-->
      <div class="template-massive__btn" *ngIf="hasBtnTypeCta">
        <div class="template-massive__btn__cta">
          <div
            class="template-massive__btn__item"
            *ngIf="template['labelPhone'] !== null">
            <mat-icon
              style="vertical-align: middle; font-size: 20px"
              aria-hidden="true"
              >phone
            </mat-icon>
            {{ template['labelPhone'] }}
          </div>
          <div
            class="template-massive__btn__item"
            *ngIf="template['labelUrl'] !== null">
            <mat-icon
              style="vertical-align: middle; font-size: 20px"
              aria-hidden="true">
              open_in_new
            </mat-icon>
            {{ template['labelUrl'] }}
          </div>
          <div
            class="template-massive__btn__item"
            *ngIf="
              template['labelFlow'] !== null && template['labelFlow'] !== undefined
            ">
            <mat-icon
              style="vertical-align: middle; font-size: 20px"
              aria-hidden="true">
              description
            </mat-icon>
            {{ template['labelFlow'] }}
          </div>
        </div>
      </div>
      <div class="template-massive__btn" *ngIf="hasBtnTypeRequestContactInfo">
        <div class="template-massive__btn__cta">
          <div class="template-massive__btn__item">
            <mat-icon
              style="vertical-align: middle; font-size: 20px"
              aria-hidden="true">
              contact_phone
            </mat-icon>
            {{ 'TEMPLATE.LABEL.OPTION.REQUEST_CONTACT_INFO' | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- QUICK REPLY -->
    <div class="template-massive__quick-reply" *ngIf="hasBtnTypeQuickReply">
      <ng-container *ngFor="let quickReply of quickReplyList">
        <div class="template-massive__quick-reply__item">
          {{ quickReply }}
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- EMPTY MESSAGE -->
  <div class="template-massive__empty" *ngIf="!template">
    <h3>El template no contiene datos...</h3>
  </div>
</div>
